import React, { createContext, useContext } from 'react';

const DEFAULT_LIMITS = {
  max_active_tournaments: null,
  allowed_tournament_types: null,
  max_courts: null,
  custom_logo: true,
  presentation_view: true,
  multiple_admins: true,
  activity_log: true,
};

export const PlanContext = createContext({
  plan: 'pro',
  limits: DEFAULT_LIMITS,
});

export const usePlan = () => useContext(PlanContext);
